export default "__VITE_ASSET__0YqC0k3X__"